module.exports = __webpack_public_path__ + "img/zh.36dab50f.svg";